$(window).on('load', function() {

  /***
  PLP - FILTERS
  ***/
  const target = document.querySelector('.usf-sr-config');
  if (!target) return;

  let lastScroll = window.scrollY;

  window.addEventListener('scroll', () => {
    const currentScroll = window.scrollY;
      if (currentScroll > lastScroll) {
        // Scroll verso il basso
        target.classList.add('hidden');
      } else {
        // Scroll verso l'alto
        target.classList.remove('hidden');
      }
      lastScroll = currentScroll;
  });

})(window, document);